import PropTypes from "prop-types";

/* Reference / meta line / status pill, used at the top of both results. */
const SummaryBar = ({ eyebrow, reference, meta, badge, tone }) => (
  <section className="c4rtn__summary">
    <div className="c4rtn__summary-main">
      <p className="c4rtn__summary-eyebrow">{eyebrow}</p>
      <h2 className="c4rtn__summary-id">{reference}</h2>
      <p className="c4rtn__summary-meta">
        {meta.filter(Boolean).map((entry, index) => (
          <span key={entry}>
            {index > 0 ? <span aria-hidden="true"> · </span> : null}
            {entry}
          </span>
        ))}
      </p>
    </div>

    {badge ? (
      <span className={`c4rtn__badge c4rtn__badge--${tone}`}>{badge}</span>
    ) : null}
  </section>
);

SummaryBar.propTypes = {
  eyebrow: PropTypes.string.isRequired,
  reference: PropTypes.string,
  meta: PropTypes.array,
  badge: PropTypes.string,
  tone: PropTypes.string,
};

SummaryBar.defaultProps = { meta: [] };

export default SummaryBar;
